import { render, staticRenderFns } from "./RolesSwitcher.vue?vue&type=template&id=65c9371c&"
import script from "./RolesSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RolesSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./RolesSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports